<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="拍卖场次">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.title"
        ></a-input>
      </a-form-item>

      <a-form-item label="开始时间">
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.start_at" />
      </a-form-item>

      <a-form-item label="结束时间">
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.end_at" />
      </a-form-item>

      <a-form-item label="备注信息">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">添加拍卖</a-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      form: {
        title: "",
        start_at: null,
        end_at: null,
        desc: ""
      }
    };
  },
  methods: {
    moment,
    async sub() {
      const that = this;

      if (!this.form.title) return this.$message.error('请填写场次');
      if (!this.form.start_at) return this.$message.error('请选择开始时间');
      if (!this.form.end_at) return this.$message.error('请选择结束时间');

      const r = await that.$axios.post("/auction/create", this.form);

      if (r.status == 1) {
        this.$router.push("/auction/list");
      }
    }
  },
};
</script>
